<template>
	<svg
		width="15"
		height="12"
		viewBox="0 0 15 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.7865 2.32684e-06L1.21516 1.77732e-06C0.256531 1.73542e-06 -0.325927 1.02906 0.195858 1.82155L6.48155 11.4497C6.59099 11.6183 6.74239 11.7571 6.92167 11.8533C7.10094 11.9495 7.30227 12 7.50692 12C7.71157 12 7.9129 11.9495 8.09217 11.8533C8.27145 11.7571 8.42285 11.6183 8.53229 11.4497L14.8058 1.82155C14.9242 1.64314 14.991 1.4369 14.9992 1.22457C15.0073 1.01225 14.9565 0.80172 14.8521 0.615192C14.7478 0.428664 14.5937 0.273055 14.4061 0.164779C14.2186 0.0565031 14.0045 -0.000424243 13.7865 2.32684e-06Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "ArrowIcon",
};
</script>
